import React, {
  forwardRef,
  useCallback,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import API from "api";
import { Card, Col, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import FullScreen from "assets/images/FullScreen.png";
import DarkMode from "assets/images/DarkMode.png";
import ExitFullScreen from "assets/images/ExitFullScreen.png";
import LightMode from "assets/images/LightMode.png";
import { toggleFullScreen, toggleTheme, isFullScreen, isDarkMode } from "util/helper";

const TestHeader = forwardRef(({ mockData, setMockData, id, routeState,
  soundArr,
  timerRef, finalObjectCreation, finalSubmit }, ref) => {
  const intStatus = useSelector((state) => state.intStatus);
  const [time, setTime] = useState(mockData.secondCount);
  const [qTime, setQTime] = useState(mockData.qTime);
  const currentQuestion = mockData.currentQuestion;
  const totalTime = mockData.secondCount;
  const tempRef = useRef(time);
  const mockRef = useRef(mockData);
  const hasSubmittedRef = useRef(false);
  const intervalIdRef = useRef(null);
  const [, forceUpdate] = useState();
  useEffect(() => {
    setTime(totalTime);
  }, [totalTime]);

  useEffect(() => {
    setQTime(0);
  }, [currentQuestion]);


const timer = useCallback(() => {
  let connection;
  if (typeof intStatus === undefined || typeof intStatus === "undefined") {
    connection = true;
  } else {
    connection = intStatus;
  }

  if (connection) {
    if (!mockRef.current.internet) {
      setMockData((prevState) => {
        return { ...prevState, internet: true };
      });
    }

    if (Number(Math.round(tempRef.current.toFixed(1))) === 0) {
      let intervalId;
      setMockData((prevState) => {
        intervalId = prevState.intervalId;
        return {
          ...prevState,
          dashboardFlag: true,
          timeOutFlag: true,
          timeOut: true,
          stopRecording: true,
          pending: 1,
          nextType: 1,
          complete: 1,
          secondCount: tempRef.current,
          qTime,
        };
      });
// Auto-submit current question when time runs out - ONLY ONCE
if (finalObjectCreation && finalSubmit && !hasSubmittedRef.current) {
  console.log("=== Starting submission process ===");
  hasSubmittedRef.current = true;

  try {
    let obj1 = finalObjectCreation();
    console.log("obj1 created:", obj1);
    
    const submitResult = finalSubmit(obj1);
    console.log("finalSubmit called, result:", submitResult);
    
            Promise.resolve(submitResult)
              .then((res) => {
                console.log("=== Got response from finalSubmit ===");
                console.log("response-----------", res);

                // Check response status
                const isSuccess =
                  res?.status === 200 ||
                  res?.statusCode === 200 ||
                  res?.data?.status === 200 ||
                  res?.success === true;

                console.log("Is success:", isSuccess);

                if (!isSuccess) {
                  console.error("First submission failed:", res);
                  throw new Error("Submission failed");
                }

                // Call second API after first one succeeds
                console.log("=== Preparing to call set/mockTime ===");
                let bodyFormData = new FormData();
                bodyFormData.append("mock_id", id);

                mockRef.current.ids.forEach((v, k) => {
                  if (k !== 0) {
                    bodyFormData.append("id[]", `${v.id}-${v.question_number}`);
                  }
                });

                console.log("Calling set/mockTime API...");
                
                if(submitResult){
                   return API({
                  method: "Post",
                  url: "set/mockTime",
                  data: bodyFormData,
                });
                }
              })
              .then((secondRes) => {
                console.log("=== Mock time set successfully ===", secondRes);
                // Stop timer after successful API calls
                clearInterval(intervalId);
              })
              .catch((error) => {
                console.error("=== Error in submission process ===", error);
                console.error("Error stack:", error.stack);
                hasSubmittedRef.current = false;
                // Stop timer even on error
                clearInterval(intervalId);
              });
  } catch (error) {
    console.error("=== Caught synchronous error ===", error);
    hasSubmittedRef.current = false;
  }
} else {
  console.log("Submission conditions not met:", {
    hasFinalObjectCreation: !!finalObjectCreation,
    hasFinalSubmit: !!finalSubmit,
    alreadySubmitted: hasSubmittedRef.current
  });
}
      
      clearInterval(intervalId);
      return;
    }
    setTime((prevState) => {
      const newTime = Math.max(0, prevState - 1);
      tempRef.current = newTime;
      return newTime;
    });
    setQTime((prevState) => prevState + 1);
  } else {
    if (mockRef.current.internet) {
      setMockData((prevState) => {
        return { ...prevState, internet: false };
      });
    }
  }
}, [mockRef, intStatus]);

  useEffect(() => {
    let intervalId = setInterval(timer, 1000);
    intervalIdRef.current = intervalId;
    setMockData((prevState) => {
      return { ...prevState, intervalId };
    });

    return () => {
      clearInterval(intervalId);
    };
  }, [timer]);

  useEffect(() => {
    mockRef.current = mockData;
    // Expose stopTimer function
    if (mockData.stopTimer) {
      console.log("[TIMER] stopTimer flag detected, clearing interval:", intervalIdRef.current);
      if (intervalIdRef.current) {
        clearInterval(intervalIdRef.current);
        intervalIdRef.current = null;
      }
    }
  }, [mockData]);

  const callbackHandler = () => {
    return {
      timerData() {
        return { qTime, time };
      },
    };
  };


  useImperativeHandle(ref, callbackHandler);
  
  return (
    <Row className="m-0 test_width">
      <Row
        className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center w-100 mock-header-bg py-2"
        style={{
          height: "40px	!important",
        }}
      >
        <Col
          xs={12} md="auto" className="p-0"
        >
          <Card.Title tag="h4" className="m-0 mx-2">
            Language Academy - {mockData.title}
          </Card.Title>
        </Col>
        <Col xs={12} md="auto" className="text-md-end">
          <div className="text-start text-md-end questionTime p-2">
            <div className="timeRemaining">
              <p>
                <i className="fa fa-clock-o"></i>
                <span>
                  Time Remaining:
                  {Math.floor(Math.max(0, time) / 60) + ":" + parseInt(Math.max(0, time) % 60)}
                </span>
              </p>
            </div>
            <div className="item">
              <p>
                Question {mockData.currentQuestion + mockData.qCount + 1} of{" "}
                {/* {mockData.questionData.length + mockData.qCount} */}
                {mockData.mock.question_count}
              </p>
            </div>
          </div>
        </Col>
      </Row>
      <Row
        style={{
          backgroundColor: "#0081A4",
          minHeight: "40px",
        }}
        className="d-flex justify-content-end align-items-center px-4"
      >
        <div className="d-flex justify-content-end gap-3">
          <img
            src={isFullScreen() ? ExitFullScreen : FullScreen}
            onClick={() => {
            toggleFullScreen();
            setTimeout(() => {
									forceUpdate({});
								}, 100);
            }}
            alt={isFullScreen() ? "Exit Full Screen" : "Full Screen"}
            className="toggle-icons"
          />
          <img
            src={isDarkMode() ? LightMode : DarkMode}
            onClick={() => {
            toggleTheme();
            forceUpdate({});
            }}
            alt={isDarkMode() ? "Light Mode" : "Dark Mode"}
            className="toggle-icons"
          />		
        </div>
      </Row>
    </Row>

  );
});

export default TestHeader;
